import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import type { Theme} from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import React, { useContext, useEffect, useState } from 'react';
import type { JSX } from 'react';
import PurchaseLogo from '../../Assets/Svg/PurchaseLogo';
import type { SystemContextProps } from '../../Contexts/SystemContext';
import SystemContext from '../../Contexts/SystemContext';
import { appBarHeight, appVersion, navBarHeight } from '../../Constants';
import { useTitle } from 'shouldve-been-react';

type AboutSubTabProps = {
    closeSubTab: () => void,
};

function AboutSubTab(props: Readonly<AboutSubTabProps>): JSX.Element {

    useTitle('K-Fleet Purchase - About');

    const systemContext: SystemContextProps = useContext<SystemContextProps>(SystemContext);

    const currentTheme: Theme = useTheme();

    const [windowSize, setWindowSize] = useState<[number, number]>([1920, 1080]);

    useEffect(() => {

        function updateSize(): void {
            setWindowSize([window.innerWidth, window.innerHeight]);
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
        <>
            <AppBar 
                position='sticky'
                elevation={0}
                style={{
                    background: currentTheme.palette.background.paper,
                    height: appBarHeight,
                }}
            >
                <Toolbar style={{
                    justifyContent: 'left',
                }}>
                    <IconButton 
                        edge='end' 
                        color='inherit' 
                        onClick={(): void => props.closeSubTab()}
                    >
                        <FontAwesomeIcon
                            icon={faArrowLeft}
                            color={currentTheme.palette.text.primary}    
                        />
                    </IconButton>
                    <Typography style={{
                        marginLeft: '40px',
                        color: currentTheme.palette.text.primary,
                    }}>
                        About
                    </Typography>
                </Toolbar>
            </AppBar>
            <div style={{
                textAlign: 'center',
                padding: '55px 5px 5px 5px',
                height: windowSize[1] - navBarHeight - appBarHeight,
                overflow: 'auto',
            }}>
                <table 
                    cellPadding={10}
                    style={{
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                >
                    <tbody>
                        <tr>
                            <td>
                                <PurchaseLogo
                                    color={currentTheme.palette.text.primary}
                                    height={120}
                                />
                            </td>
                            <td>
                                <img 
                                    src={systemContext.logoUrl ?? ''}
                                    alt='Logo' 
                                    height='120px'
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <Typography 
                                    variant='h5'
                                    style={{
                                        color: currentTheme.palette.text.primary,
                                        fontFamily: 'Permanent Marker',
                                    }}
                                >
                                    K-Fleet Purchase
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <Typography 
                                    variant='h6'
                                    style={{
                                        color: currentTheme.palette.text.primary,
                                    }}
                                >
                                    {systemContext.systemName ?? 'ERROR'}
                                </Typography>
                            </td>
                        </tr>
                        <tr>
                            <td style={{
                                paddingTop: '50px',
                            }}>
                                <Typography
                                    style={{
                                        color: currentTheme.palette.text.primary,
                                    }}
                                >
                                    Version
                                </Typography>
                                <Typography
                                    style={{
                                        color: currentTheme.palette.text.primary,
                                    }}
                                >
                                    {appVersion}
                                </Typography>
                            </td>
                            <td style={{
                                paddingTop: '50px',
                            }}>
                                <a
                                    href='/LICENSE.md'
                                    target='_blank'
                                    rel='noreferrer'
                                    style={{
                                        color: currentTheme.palette.text.primary,
                                    }}
                                >
                                    Licenses
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default AboutSubTab;
